<template>
    <div v-if="videoObject" class="page-box" v-title data-title="视频分享">
        <div class="page-video-box">
            <div class="page-video" :class="fullscreen ? 'fullscreen' : ''">
                <video
                    id="videoplayer"
                    class="videoClass"
                    :src="videoObject.videoPath"
                    preload="auto"
                    x5-playsinline
                    webkit-playsinline
                    playsinline
                    x-webkit-airplay="allow"
                    x5-video-player-type="h5"
                >
                    你的浏览器太low了！！
                </video>
                <img
                    v-if="state == 'oncreate'"
                    :src="videoObject.coverPath"
                    class="video-default-image"
                />

                <img :src="watermark" class="watermark-image" />
                <div class="video-object">
                    <div class="video-name">{{ videoObject.remark }}</div>
                    <div class="video-desc">
                        <div class="video-frequency">
                            {{ videoObject.videoStatistics.playNumber }}次播放
                        </div>
                        <div class="video-time">{{ videoObject.createdTime }}</div>
                    </div>
                </div>
            </div>
            <div v-if="state == 'oncreate'" class="maxscreen center" v-on:click="startvideo">
                <img :src="playImage" class="play-image" />
            </div>

            <div v-if="state == 'onpause'" class="maxscreen center" v-on:click="startvideo">
                <img :src="playImage" class="play-image" />
            </div>

            <div v-if="state == 'onstart'" class="maxscreen" v-on:click="pausevideo"></div>

            <div
                v-if="state == 'onfinish'"
                class="maxscreen center hasground"
                v-on:click="aginvideo"
            >
                <img :src="replayImage" class="replay-image" />
                <div v-if="videoObject.product" class="goods-view" v-on:click="downloadapp">
                    <div class="goods-picture">
                        <img :src="tagImage" class="goods-tag" />
                        <img :src="videoObject.product.product_image" class="goods-product-image" />
                    </div>
                    <div class="goods-named">
                        <div class="goods-name">{{ videoObject.product.product_name }}</div>
                        <div class="goods-price">
                            ¥{{ videoObject.product.product_unit_price || '0.00' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="videoObject.hotVideos && videoObject.hotVideos.length > 0"
            class="page-more-list"
        >
            <div class="morescreen center">
                <div class="morescreentext">— 更多热门吆呵 —</div>
            </div>
            <div class="morelist">
                <div
                    v-for="(item, index) in videoObject.hotVideos"
                    :key="index"
                    class="more-item"
                    :class="index % 2 == 0 ? 'odd' : 'even'"
                    v-on:click="openVideoDetail(item.id)"
                >
                    <img :src="item.coverPath" class="more-image-item" />
                </div>
            </div>
        </div>
        <div class="page-download">
            <img :src="logoImage" class="logo-image" />
            <div class="download-btn">
                <img :src="downloadImage" class="btn-image" />
                <div class="download-btn-text" v-on:click="downloadapp">打开</div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '../../api/index';
import { downloadapp } from '../../until/common';

export default {
    name: 'videoplayer',
    data: function() {
        return {
            playImage: require('../../assets/play.png'),
            replayImage: require('../../assets/replay.png'),
            logoImage: require('../../assets/logo.png'),
            watermark: require('../../assets/watermark.png'),
            downloadImage: require('../../assets/btnbg.png'),
            tagImage: require('../../assets/goodtag.png'),
            videoObject: null, // 视频数据
            videoId: null, // 视频id
            fullscreen: false, // 判断是否全屏
            isIOS: false,
            state: 'oncreate' // oncreate初始化
        };
    },

    watch: {
        $route(to, from) {
            //监听路由是否变化
            if (to.query.videoId != from.query.videoId) {
                this.videoId = to.query.videoId;
                window.scrollTo(0, 0);
                this.init();
            }
        }
    },
    methods: {
        init() {
            this.state = 'oncreate';
            this.fullscreen = false;
            this.getVideoList();
        },
        // 开始播放视频
        startvideo() {
            console.log('videoObject:', this.videoObject);
            if (this.videoObject.delete) {
                this.$toast('该视频已被删除', 2000);
                return false;
            }
            if (!this.player) {
                this.player = document.getElementById('videoplayer');
                this._firstFullscreen = true;
                const that = this;
                document.addEventListener('fullscreenchange', function(e) {
                    console.log('fullscreenchange', e);
                    if (that._firstFullscreen) {
                        that.player.cancelFullScreen();
                        that._firstFullscreen = false;
                    }
                });
                document.addEventListener('mozfullscreenchange', function(e) {
                    console.log('mozfullscreenchange ', e);
                    if (that._firstFullscreen) {
                        that.player.cancelFullScreen();
                        that._firstFullscreen = false;
                    }
                });
                document.addEventListener('webkitfullscreenchange', function(e) {
                    console.log('webkitfullscreenchange', e);
                    if (that._firstFullscreen) {
                        that.player.cancelFullScreen();
                        that._firstFullscreen = false;
                    }
                });
                document.addEventListener('msfullscreenchange', function(e) {
                    console.log('msfullscreenchange', e);
                    if (that._firstFullscreen) {
                        that.player.cancelFullScreen();
                        that._firstFullscreen = false;
                    }
                });
                document.addEventListener('x5videoexitfullscreen', () => {
                    if (window.WeixinJSBridge) window.WeixinJSBridge.call('closeWindow');
                });

                // 监听视频播放开始
                this.player.addEventListener('play', () => {
                    this.state = 'onstart';
                    this.fullscreen = true;
                    // console.log('监听视频播放开始');
                });

                // 监听视频播放暂停
                this.player.addEventListener('pause', () => {
                    this.state = 'onpause';
                    // console.log('监听视频播放暂停');
                });

                // 监听视频播放完成
                this.player.addEventListener('ended', () => {
                    this.state = 'onfinish';
                    this.fullscreen = false;
                    // console.log('监听视频播放完成');
                });

                // 监听视频播放报错
                this.player.addEventListener('error', () => {
                    this.state = 'onfail';
                    this.$toast('视频播放出错了！', 2000);
                    // console.log('监听视频播放报错');
                });
            }
            // console.log('startvideo:', this.player);
            this.player.play();
        },
        // 暂停播放视频
        pausevideo() {
            this.player.pause();
        },
        // 继续播放视频
        aginvideo() {
            this.player.play();
        },
        getVideoList() {
            API.Video.getVideoAndHot({
                videoId: this.videoId
            }).then(
                resdata => {
                    // console.log('get ok:', resdata);
                    this.videoObject = resdata;
                },
                err => {
                    // console.log('get err:', err);
                    this.$toast(err.desc, 2000);
                }
            );
        },
        downloadapp,
        openVideoDetail(videoId) {
            console.log('videoId:', videoId);
            this.$router.push(`/video?videoId=${videoId}`);
        }
    },
    created() {
        const videoId = this.$route.query.videoId;
        if (!videoId) {
            this.$toast('参数错误！', 2000);
            return false;
        } else {
            this.videoId = videoId;
            this.init();
        }
    }
};
</script>

<style scoped>
.page-box {
    width: 100%;
    /* height: 100%;
    overflow: auto; */
    -webkit-overflow-scrolling: touch;
}

.page-video-box {
    width: 7.5rem;
    min-height: 9.97rem;
    position: relative;
}

.page-video {
    width: 7.5rem;
    height: 9.97rem;
    transition: all 0.3s;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: #000;
}

.page-video.fullscreen {
    width: 7.5rem;
    height: auto;
    min-height: 9.97rem;
}

.videoClass {
    display: inline-block;
    width: 7.5rem;
    /* height: 100%; */
    position: relative;
    z-index: 1;
    object-fit: cover;
}

.maxscreen {
    position: absolute;
    z-index: 9;
    width: 7.5rem;
    height: 100%;
    left: 0;
    top: 0;
}

.hasground {
    background: rgba(0, 0, 0, 0.5);
}

.watermark-image {
    width: 1.71rem;
    height: 0.67rem;
    position: absolute;
    left: 0.42rem;
    top: 0.42rem;
    z-index: 8;
}

.video-object {
    width: 7.5rem;
    height: 5.26rem;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 8;
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
}

.video-name {
    width: 7.5rem;
    position: absolute;
    bottom: 1rem;
    font-size: 0.34rem;
    color: #fff;
    padding: 0 0.3rem;
    box-sizing: border-box;
}

.video-desc {
    width: 7.5rem;
    position: absolute;
    bottom: 0.45rem;
    font-size: 0.34rem;
    color: #b8b8b9;
    display: flex;
    justify-content: space-between;
    padding: 0 0.3rem;
    box-sizing: border-box;
}

.video-frequency {
    font-size: 0.24rem;
}

.video-time {
    font-size: 0.2rem;
}

.center {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
}

.play-image {
    width: 1.81rem;
    height: 1.81rem;
    z-index: 10;
    position: relative;
}

.video-default-image {
    width: 7.5rem;
    /* height: 100%; */
    position: absolute;
    z-index: 1;
    /* left: 0; */
}

.replay-image {
    width: 1.93rem;
    height: 0.56rem;
}

.morelist {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
}

.more-item {
    width: 3.71rem;
    height: 2.25rem;
    margin-bottom: 0.07rem;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
}

.more-item.odd {
    margin-right: 0.07rem;
}

.more-image-item {
    width: 3.71rem;
    position: absolute;
    margin: auto;
}

.morescreen {
    width: 7.5rem;
    height: 0.82rem;
    background: #fff;
}

.morescreentext {
    font-size: 0.3rem;
    color: #0d0d0d;
}

.goods-view {
    width: 2.96rem;
    height: 2.2rem;
    background: #fff;
    border-radius: 0.1rem;
    margin-top: 0.49rem;
    overflow: hidden;
}

.goods-picture {
    width: 2.96rem;
    height: 1.6rem;
    position: relative;
    background: #eee;
    overflow: hidden;
}

.goods-product-image {
    width: 2.96rem;
    height: auto;
}

.goods-tag {
    width: 1.63rem;
    height: 0.63rem;
    position: absolute;
    left: 0;
    top: 0.05rem;
}

.goods-named {
    width: 2.96rem;
    height: 0.6rem;
    display: flex;
    align-items: center;
    padding: 0 0.2rem;
    box-sizing: border-box;
}

.goods-name {
    flex: 1;
    width: 0;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: normal;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    font-size: 0.28rem;
    color: #000;
}

.goods-price {
    font-size: 0.24rem;
    color: #ff5d00;
}

.page-download {
    width: 7.5rem;
    height: 1.2rem;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.3rem;
    box-sizing: border-box;
}

.logo-image {
    width: 2.3rem;
    height: 0.85rem;
}

.download-btn {
    width: 1.41rem;
    height: 0.51rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.download-btn-text {
    font-size: 0.24rem;
    color: #fff;
    position: relative;
}

.btn-image {
    width: 100%;
    height: 100%;
    position: absolute;
}
</style>